module.exports = __webpack_public_path__ + "296d10e347c7dd44d07beeb5db35e4ff.pdf";